import { createPosition } from "@shared/common/utils/create";
import shortUUID from "short-uuid";
import type { IFormSeanEllisNode, PartialNode } from "../type";

const createFormSeanEllisNode = (
  data?: PartialNode<IFormSeanEllisNode>
): IFormSeanEllisNode => {
  return {
    type: "FORM_SEAN_ELLIS",
    id: shortUUID.generate(),
    pluginData: {
      contentEditorPropSeq: 0,
      contentMeta: [],
    },
    reactions: [],
    position: createPosition(data?.position),

    name: "",

    width: { value: 100, unit: "%" },

    fills: [],

    locked: false,

    strokes: [],
    strokeWeight: 1,
    strokeAlign: "CENTER",
    strokeCap: "SQUARE",
    strokeJoin: "ROUND",
    dashPattern: [],

    visible: true,

    effects: [],
    range: {
      type: "RANGE",
      min: 0,
      max: 2,
    },

    label:
      "<p>만약 더 이상 이 제품을 이용할 수 없게 된다면 어떤 기분일까요?</p>",
    required: true,
    choiceType: "RADIO",

    ...data,

    items: data?.items
      ? data.items.map((item) => ({
          id: shortUUID.generate(),
          label: "",
          ...item,
        }))
      : [
          {
            id: shortUUID.generate(),
            label: "매우 실망스럽다",
          },
          {
            id: shortUUID.generate(),
            label: "조금 실망스럽다",
          },
          {
            id: shortUUID.generate(),
            label: "전혀 실망스럽지 않다",
          },
        ],
  };
};

export default createFormSeanEllisNode;
